<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" class="text-center">
        <v-card elevation="8" class="pa-8">
          <v-icon color="error" size="96" class="mb-4">
            mdi-lock-alert
          </v-icon>

          <h1 class="mb-2">403</h1>
          <h2 class="mb-4">Acceso denegado</h2>

          <p class="mb-6">
            No tienes permisos para acceder a esta página.
            Si crees que es un error, contacta al administrador.
          </p>

          <v-btn
            color="primary"
            large
            @click="volver"
          >
            Volver al inicio
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Forbidden',
  methods: {
    volver() {
      this.$router.push({ name: 'oportunidades' })
    }
  }
}
</script>

<style scoped>
h1 {
  font-size: 4rem;
  font-weight: 700;
}
h2 {
  font-size: 1.5rem;
  font-weight: 500;
}
p {
  color: #666;
}
</style>
